module.exports = __webpack_public_path__ + "static/img/20221213_04.0ac8697.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20221213_04.png
// module id = waGr
// module chunks = 0